import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "content", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--dashboards--dates--dashboard`
  }

  doDatesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-8 offset-2" data-${this.controllerName}-target="content" data-controller="financials--books--dashboards--dates--index"></div>
                </div>`


    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`financials--books--dashboards--main--page`).settingsTarget.innerHTML = html)
    }).then(() => {
      // controller.getControllerByIdentifier(`financials--books--dashboards--show--submenu`).dashboardToggleBtn(`COMPETÊNCIAS`)
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
